import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core'

import { HttpCssClient } from '../shared/http-request.interceptor';
import { Cookie } from '../shared/cookie.service';
import { CurrencyService } from '../shared/currency.service';
import { SuperInterceptor } from './super-interceptor.service';
import { HeaderService } from '../shared/header.service';
import { ɵDomAdapter as DomAdapter, DOCUMENT, ɵgetDOM as getDOM } from '@angular/platform-browser';
/*import { HrefLang } from '../shared/angular2-hreflang';*/

///  <reference path="../../../../node_modules/@types/jquery/index.d.ts"/>

@Injectable()
export class LanguageInterceptor extends SuperInterceptor  {
    constructor(private router:Router,private translate: TranslateService, private http: HttpCssClient, private cookie:Cookie,
        public currencyService:CurrencyService,public headerService:HeaderService, @Inject(PLATFORM_ID) private platformId:Object,
        @Inject(DOCUMENT) private document:any
    ) {
         super(router,cookie);
    };

    canActivate(prev: ActivatedRouteSnapshot, next: RouterStateSnapshot) {
        super.canActivate(prev,next);
        let lang = 'en';

        //we need to differentiate between no language param and bad language param        
        if (prev.params['language'] != null && !this.checkValidLanguage(prev.params['language'])) {
            //bad languaje param
            this.router.navigate(['/oops/404']);
            return false;
        }
        else if (prev.params != null &&  this.checkValidLanguage(prev.params['language'])) {
            lang = prev.params['language'];
        }

        this.headerService.locale = lang;        
        if (this.http.getHeader("LanguageCookie") != null){
            this.http.removeHeader("LanguageCookie");
        } 
        this.http.addHeader("LanguageCookie",lang);
        this.cookie.put("language",lang);
        this.translate.use(lang);        
        try 
        {
            if(!isPlatformBrowser(this.platformId)){
                getDOM().setAttribute(this.document.head.parent,'lang',lang);
            }
        }
        catch (ex){
            //TODO: Esto falla en server side. Cambiar.
        }

        if(this.cookie.get()["guest_session"] != null && this.cookie.get()["guest_session"] != "undefined"){
            this.http.addHeader("Authorization", this.cookie.get()["guest_session"]);
        }
        
        if(this.cookie.get()['currency'] != null){
            this.http.addHeader("CurrencyCookie",this.cookie.get()['currency']);
        }
        
        if(isPlatformBrowser(this.platformId)){
            document.body.style.overflow = "auto";
            window.scrollTo(0,0);
            //$('html, body').animate({scrollTop: '0px'}, 0)
        };
       
        return true;
    }

    public checkValidLanguage(lang:string){
        if(lang == 'es' || lang == 'en'){
            return true;
        }else{
            return false;
        }
    }
}
